import React from 'react';
import { PageHeader } from 'antd';
import { MyBreadcrumb } from 'utils';
import UsersForm from './form';
export default function UsersUpdate(props) {
    const { id } = props.match.params;
    return (
        <div>
            <MyBreadcrumb items={[{ label: "Users", path: "/users" }, { label: "Update", path: "" }]} />
            <PageHeader
                ghost={false}
                onBack={() => window.history.back()}
                title="Update"
                subTitle=""
            >
                <UsersForm id={id} />
            </PageHeader>
        </div>
    );
}